'use strict';

import angular from 'angular';
import currencyModel from '../models/currency_model.service';

const currencyInputDirective = (currencyModel) => {
  'ngInject';

  return {
    restrict: 'A',
    require: 'ngModel',
    link: ($scope, $element, $attr, ngModel) => {
      $element.on('change', () => {
        $scope.$apply(() => {
          currencyModel.saveValue(ngModel.$modelValue);
        });
      });
    }
  };
};

const dependencies = [
  currencyModel
];

export default angular
  .module('directives.currencyInput', dependencies)
  .directive('saCurrencyInput', currencyInputDirective)
  .name;



// WEBPACK FOOTER //
// ./app/src/directives/currency_input.directive.js